<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" lg="10">
        <v-card>
          <v-toolbar color="light-green darken-1" dark flat>
            <v-toolbar-title>Neue Benachrichtigung</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form
              name="formroboter"
              @submit.prevent="send"
              v-model="formValid"
            >
              <v-container>
                <v-row class="pa-0 ma-0">
                  <v-col cols="12" sm="12">
                    <v-text-field
                      label="Titel"
                      name="tile"
                      type="text"
                      color="purple"
                      :rules="requiredRule"
                      :clearable="true"
                      v-model="notification.title"
                    />
                  </v-col>
                </v-row>
                <v-row class="pa-0 ma-0">
                  <v-col cols="12" sm="12">
                    <v-text-field
                      label="Nachricht"
                      name="message"
                      type="text"
                      color="purple"
                      :rules="requiredRule"
                      :clearable="true"
                      v-model="notification.body"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      label="Click URL"
                      name="clickurl"
                      type="text"
                      color="purple"
                      :rules="requiredRule"
                      :clearable="true"
                      v-model="notification.clickUrl"
                      placeholder="https://order.anewo.at"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-switch
                      v-model="schedule"
                      label="Versand planen"
                      color="green"
                      @change="toggleSchedule"
                    />
                  </v-col>
                </v-row>
                <v-row v-show="schedule">
                  <v-col cols="12" sm="6">
                    <MenuDatePicker
                      label="Sende Datum"
                      hide-details
                      locale="de-de"
                      :first-day-of-week="1"
                      v-model="notification.sendDate"
                    />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <MenuTimePicker
                      label="Sende Zeit"
                      hide-details
                      locale="de-de"
                      :first-day-of-week="1"
                      :allowed-minutes="(v) => v % 5 == 0"
                      v-model="notification.sendTime"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :to="{ path: '/notifications' }"
              color="error"
              type="button"
              name="cancel"
              >Abbrechen</v-btn
            >
            <v-spacer />
            <v-btn
              outlined
              @click="saveDraft"
              color="success"
              name="submit"
              type="submit"
              :disabled="!formValid"
              >Entwurf speichern</v-btn
            >
            <v-btn
              @click="send"
              color="success"
              name="submit"
              type="submit"
              :disabled="!formValid"
            >
              <span v-if="!schedule">Jetzt senden</span>
              <span v-else>Planen</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MenuDatePicker from "@/components/MenuDatePicker";
import MenuTimePicker from "@/components/MenuTimePicker";
//import CustomerSelectbox from "@/components/customers/CustomerSelectbox";
import NotificationService from "@/services/NotificationService.js";
import moment from "moment";

export default {
  name: "NotificationForm",
  components: { MenuTimePicker, MenuDatePicker },
  props: [],
  data: () => ({
    requiredRule: [(value) => !!value || "Dieses Feld wird benötigt!"],
    formValid: false,
    customer: null,
    schedule: false,
  }),
  computed: {
    notification: {
      get() {
        return this.$store.getters["notification/getNotification"];
      },
      set(value) {
        this.$store.commit("notification/SET_NOTIFICATION", value);
      },
    },
  },
  methods: {
    toggleSchedule() {
      if (!this.schedule) {
        this.notification.sendTime = null;
      } else {
        this.$store.commit(
          "notification/SET_NOTIFICATION_TIME",
          moment().toDate()
        );
      }
    },
    saveDraft() {
      this.notification.status = "draft";
      this.$store
        .dispatch("notification/saveNotification")
        .then(() => {
          //if success redirect to list
          this.$router.push({ name: "notifications" });
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Benachrichtigungen gespeichert",
            text: "Benachrichtigungen erfolgreich gespeichert",
          });
        })
        .catch((error) => {
          //on error alert error
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message,
          });
        });
    },

    send() {
      this.notification.status = "pending";
      this.$store
        .dispatch("notification/sendNotification")
        .then(() => {
          //if success redirect to list
          this.$router.push({ name: "notifications" });
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Benachrichtigungen gespeichert",
            text: "Benachrichtigungen erfolgreich gespeichert",
          });
        })
        .catch((error) => {
          //on error alert error
          console.log(error);
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message,
          });
        });
    },
  },
  mounted() {
    const id = this.$route.params.id;

    if (id) {
      NotificationService.get(id)
        .then((item) => {
          this.notification = item.data.data;
        })
        .catch((error) => {
          if (error.response.status != 401) {
            this.$notify({
              group: "dataline",
              type: "error",
              title: "Fehler",
              text: error.message,
            });
          }
        });
    }
  },
};
</script>

<style scoped></style>
